import { BuildingAlertsDA } from "../../Molecules/BuildingDetails/BuildingAlerts/BuildingAlertsDA/BuildingAlertsDA";
import { BuildingConfortDA } from "../../Molecules/BuildingDetails/BuildingConfort/BuildingConfortDA/BuildingConfortDA";
import { BuildingConfortHistoric } from "../../Molecules/BuildingDetails/BuildingConfort/BuildingConfortHistoric/BuildingConfortHistoric";
import { BuildingDetail } from "../../Molecules/BuildingDetails/BuildingDetail/BuildingDetail";
import { BuildingIncidents } from "../../Molecules/BuildingDetails/BuildingDetail/BuildingIncidents/BuildingIncidents";
import { DigitalTwinPage } from "../../Molecules/BuildingDetails/BuildingDetail/Digital Twin/DigitalTwin";
import { BuildingEnergeticConsumptionDA } from '../../Molecules/BuildingDetails/BuildingEnergeticConsumption/BuildingEnergeticConsumptionDA/BuildingEnergeticConsumptionDA';
import { BuildingEnergeticConsumptionDetail } from "../../Molecules/BuildingDetails/BuildingEnergeticConsumption/BuildingEnergeticConsumptionDetail/BuildingEnergeticConsumptionDetail";
import { BuildingEnergeticConsumptionHistoric } from '../../Molecules/BuildingDetails/BuildingEnergeticConsumption/BuildingEnergeticConsumptionHistoric/BuildingEnergeticConsumptionHistoric';
import { BuildingEnergeticConsumptionHistoricNew } from "../../Molecules/BuildingDetails/BuildingEnergeticConsumption/BuildingEnergeticConsumptionHistoricNew/BuildingEnergeticConsumptionHistoricNew";
import { BuildingOccupationDA } from '../../Molecules/BuildingDetails/BuildingOccupation/BuildingOccupationDA/BuildingOccupationDA';
import { BuildingOccupationHistoric } from '../../Molecules/BuildingDetails/BuildingOccupation/BuildingOccupationHistoric/BuildingOccupationHistoric';
import { BuildingParkingDA } from "../../Molecules/BuildingDetails/BuildingParking/BuildingParkingDA/BuildingParkingDA";
import { BuildingRoomDetail } from "../../Molecules/BuildingDetails/BuildingRoomDetail/BuildingRoomDetail";

export const RegisterBuildingHelper = [
  {
    name: "Overview",
    label: "overview",
    path: "#overview",
    submenus: null,
    component: [BuildingDetail, BuildingIncidents, DigitalTwinPage],
    buttons: ['Buildings Detail', 'Incidents', 'Digital Twin'],
    hideHeader: ['Digital Twin']
  },
  {
    name: "Occupation",
    label: "occupation",
    path: "#occupation",
    submenus: null,
    component: [BuildingOccupationDA, BuildingOccupationHistoric],//BuildingRoomDetail, 
    buttons: ['Daily Analysis', 'Historic']
  },
  {
    name: "Room Detail",
    label: "roomDetail",
    path: "#roomDetail",
    submenus: null,
    component: [BuildingRoomDetail],
    buttons: ['Daily Analysis']
  },
  {
    name: "Comfort",
    label: "comfort",
    path: "#comfort",
    submenus: null,
    component: [BuildingConfortDA, BuildingConfortHistoric],
    buttons: ['Daily Analysis', 'Historic']
  },
  {
    name: "Energy Consumption",
    label: "energyConsumption",
    path: "#energyConsumption",
    submenus: null,
    component: [BuildingEnergeticConsumptionDA, BuildingEnergeticConsumptionHistoric, BuildingEnergeticConsumptionDetail, BuildingEnergeticConsumptionHistoricNew],
    buttons: ['Daily Analysis', 'Historic', 'CPE Details', 'CPE Historic']
  },
  {
    name: "Parking",
    label: "parking",
    path: "#parking",
    submenus: null,
    component: [BuildingParkingDA],
    buttons: ['Daily Analysis']
  },
  {
    name: "Alerts",
    label: "alerts",
    path: "#alerts",
    submenus: null,
    component: [BuildingAlertsDA],
    buttons: ['Daily Analysis']
  }
];
